/**
 * Opzioni del selettore voce del connettore vocale.
 *
 * Il valore del Select porta con sé il provider (`"<provider>:<voiceId>"`):
 * il solo voiceId non basta più da quando il catalogo ha due provider.
 *
 * La voce **attualmente su Vapi** ha la precedenza su quella salvata in
 * piattaforma: le due possono divergere, perché chi tara l'agente cambia voce
 * direttamente su Vapi, e un select che mostrasse il nostro valore mentirebbe.
 * Se quella voce è fuori catalogo compare in un gruppo a sé: sceglierla
 * significa "lasciala com'è", e il backend infatti non la riscrive.
 */

const PROVIDER_LABELS = { azure: 'Azure', vapi: 'Vapi' };
const PROVIDER_ORDER = ['azure', 'vapi'];

export function voiceKey(provider, voiceId) {
  return `${provider || ''}:${voiceId || ''}`;
}

export function parseVoiceKey(key) {
  const raw = String(key || '');
  const i = raw.indexOf(':');
  if (i < 0) return { provider: '', voiceId: '' };
  return { provider: raw.slice(0, i), voiceId: raw.slice(i + 1) };
}

export function buildVoiceGroups({ voices = [], current = null, savedProvider = '', savedVoiceId = '', remoteGroupLabel = '' } = {}) {
  const groups = [];

  if (current && current.inCatalog === false) {
    groups.push({
      key: 'remote',
      label: remoteGroupLabel,
      items: [{ label: `${current.provider} / ${current.voiceId}`, value: voiceKey(current.provider, current.voiceId) }],
    });
  }

  PROVIDER_ORDER.forEach((provider) => {
    const items = voices
      .filter((v) => v.provider === provider)
      .map((v) => ({ label: v.label, value: voiceKey(v.provider, v.voiceId) }));
    if (items.length > 0) groups.push({ key: provider, label: PROVIDER_LABELS[provider], items });
  });

  const all = groups.flatMap((g) => g.items.map((i) => i.value));
  if (all.length === 0) return { groups: [], selected: null };

  const candidates = [
    current ? voiceKey(current.provider, current.voiceId) : null,
    savedVoiceId ? voiceKey(savedProvider || 'azure', savedVoiceId) : null,
    // Connettori salvati prima del catalogo: c'è il voiceId ma non il provider.
    savedVoiceId ? all.find((v) => parseVoiceKey(v).voiceId === savedVoiceId) : null,
  ];
  const selected = candidates.find((c) => c && all.includes(c)) || all[0];
  return { groups, selected };
}
